import React from 'react'
import styles from './SidePanelContent.module.scss'
import classNames from 'classnames'
import { SidePanelContentProps } from './types'
import AnnouncementsPanel from '../AnnouncementsPanel'
import DetailsSidePanel from '../DetailsSidePanel'
import FeatureFlagsPanel from '../FeatureFlagsPanel'
import ParticipantsPanel from '../ParticipantsPanel'
import PresentersChatPanel from '../PresentersChatPanel'
import QuestionsSidePanel from '../QuestionsSidePanel'
import SessionStatusPanel from '../SessionStatusPanel'
import VotesPanel from '../VotesPanel'
import AttachmentsPanel from '../AttachmentsPanel'

const _ID = 'Side-Panel-Content'

const SidePanelContent: React.FC<SidePanelContentProps> = (props) => (

  <React.Fragment>
    {
      props.featureFlags.questions && <div
        className={classNames(styles['side-panel-content'], {
          [styles['side-panel-content--active']]: props.menuItemSelected === 'questions'
        })}
        data-bdd={`${_ID}-Questions`}
      >
        <QuestionsSidePanel />
      </div>
    }
    <div
      className={classNames(styles['side-panel-content'], {
        [styles['side-panel-content--active']]: props.menuItemSelected === 'details'
      })}
      data-bdd={`${_ID}-Details`}
    >
      <DetailsSidePanel />
    </div>
    <div
      className={classNames(styles['side-panel-content'], {
        [styles['side-panel-content--active']]: props.menuItemSelected === 'chat'
      })}
      data-bdd={`${_ID}-Chat`}
    >
      <PresentersChatPanel />
    </div>
    {
      props.featureFlags.votes &&
      <div
      className={ classNames(styles['side-panel-content'], {
        [styles['side-panel-content--active']]: props.menuItemSelected === 'votes'
      }) }
      data-bdd={ `${ _ID }-Votes` }
    >
      <VotesPanel/>
    </div>
    }
    {
      props.featureFlags.attachments &&
      <div
      className={ classNames(styles['side-panel-content'], {
        [styles['side-panel-content--active']]: props.menuItemSelected === 'attachments'
      }) }
      data-bdd={ `${ _ID }-Attachments` }
    >
      <AttachmentsPanel />
    </div>
    }
    {
      props.debug &&
        <div
          className={classNames(styles['side-panel-content'], {
            [styles['side-panel-content--active']]: props.menuItemSelected === 'featureFlags'
          })}
          data-bdd={`${_ID}-Features`}
        >
          <FeatureFlagsPanel />
        </div>
    }
    <div
      className={classNames(styles['side-panel-content'], {
        [styles['side-panel-content--active']]: props.menuItemSelected === 'participants'
      })}
      data-bdd={`${_ID}-Participants`}
    >
      <ParticipantsPanel />
    </div>
    {
      props.debug &&
      <div
        className={classNames(styles['side-panel-content'], {
          [styles['side-panel-content--active']]: props.menuItemSelected === 'sessionStatus'
        })}
        data-bdd={`${_ID}-Session-Status`}
      >
        <SessionStatusPanel />
      </div>
    }
    {
      props.featureFlags.announcements &&
      <div
        className={classNames(styles['side-panel-content'], {
          [styles['side-panel-content--active']]: props.menuItemSelected === 'announcements'
        })}
        data-bdd={`${_ID}-Announcements`}
      >
        <AnnouncementsPanel />
      </div>
    }

  </React.Fragment>

)

export default SidePanelContent
